

// CAPS Application Common State Objects
// CAPS Login Object
export const CAPSLogInObject = {
    email: "",
    password: "",
};
export const EducationDetails = {
    educationalQualificationId: 0,
    cpasMemberid: 0,
    nameOfInstitution: "",
    titleOfCourse: "",
    qualificationTypeId: 0,
    qualificationTypeName: "",
    yearOfAward: "",
    durationOfProgramme: "",
    certificateOfEducation: "",
};
export const ProfessionalQualificationDetail = {
    professionalQualificationId: 0,
    cpasMemberid: 0,
    professionalQualification: "",
    organisation: "",
    validityDuration: "",
    gradeOfMembership: "",
    certificateFilePath: ""
};
export const ProfessionalQualificationDetailIfApplicable = {
    professionalQualificationApplicableId: 0,
    cpasMemberid: 0,
    professionalQualificationName: "",
    organisation: "",
    validityDuration: "",
    gradeOfMembership: "",
    certificatePath: ""
};

// CAPS Basic Application Object
export const CAPSBasicApplicationObject = {
    cpasMemberid: 0,           // Primary key
    applicationTierId: 0,
    mrMrsId: 0, // Nullable
    firstName: "",             // Nullable
    lastName: "",              // Nullable
    dateOfBirth: null,
    NRIC_Passport_WorkPassNo: "",       // Nullable
    identificationNo: "",      // NRIC/Passport/Work Pass
    isSexMale: false,                 // true/false or 'M'/'F', nullable
    mailingAddressLine1: "",       // Nullable
    mailingAddressLine2: "",       // Nullable
    mailingAddressLine3: "",       // Nullable
    postalCode: null,            // Nullable
    countryId: 0,           // Nullable
    contactNumber: "",         // Nullable
    emailAddress: "",          // Nullable
    placeOfBirthId: 0,      // Nullable
    nationalityId: 0,       // Nullable
    // Nullable
    photoFilePath: "",         // Nullable
    uploadPaymentProof: "",
    comments: "",
    password: "",
    confirmPassword: "",
    statusId: 0,
    password: "",
    confirmPassword: "",
    submissionDate: null,
    paymentStatus: 0,
    statusName: "",
    appealComment: "",
    paymentStatusForAppeal: ""

};

export const ProjectandPaymentInfoObj = {
    paymentProofFilePath: "",
    PaymentProofComment: "",
    accreditedConProReportPath: ""
}
export const cpdSubmissionDetailsObj = {
    cpasMemberid: 0,
    isLapseBenefitUsed: false,
    totalApprovedCPD: "",
    requiredPointsForNextRenewal: 0,
    requiredPointsForCurruntRenewal: 0,
    availableCarryForwardPoints: 0,
    curruntTotalApprovedCPD: 0
}

export const OrganisationReference = {
    cpasMemberid: 0,

    // First Reference - Existing
    referenceFirstName: "",
    referenceLastName: "",
    referenceEmailAddress: "",
    referenceOrganisation: "",
    referenceOrganisationAddress: "",
    referenceRelationship: "",
    referenceContactNumber: "",
    periodKnownInMonths: null,
    referenceDocumentFilePath: "",

    // Second Reference - New
    secondReferenceFirstName: "",
    secondReferenceLastName: "",
    secondReferenceEmailAddress: "",
    secondReferenceOrganisation: "",
    secondReferenceOrganisationAddress: "",
    secondReferenceRelationship: "",
    secondReferenceContactNumber: "",
    secondPeriodKnownInMonths: null,
    secondReferenceDocumentFilePath: ""
};

// CAPS Educational Information Object
export const CAPSEducationalInformationObject = {
    educationQualoification: [],
    professionalQualification: [],
};
// CAPS Educational Qualification Object
export const CAPSEducationalQualificationObject = {
    nameOfInstitution: "",
    titleOfCourse: "",
    qualificationTypeId: 0,
    qualificationTypeLabel: "",
    awardYear: "",
    programmeDuration: "",
    uploadFiles: [],
};
// CAPS Professional Qualification Object
export const CAPSProfessionalQualificationObject = {
    professionalQualification: "",
    organisation: "",
    validityDuration: "",
    membershipGradeId: 0,
    membershipGradeLabel: "",
    uploadFilesWSQ: [],
    uploadFilesApplicable: [],
};
// CAPS Employment Information Object
export const CAPSEmploymentInformationObject = {
    employmentHistory: [],
    professionalReference: [],
    isConstructionCompany: true,
};
// CAPS Employment History Object
export const CAPSEmploymentHistoryObject = {
    nameOfCompany: "",
    lastCurrentPositionHeld: "",
    employmentDuratation: "",
    dateFrom: "",
    dateTo: "",
    projectInvolved: "",
    role: "",
    contractValue: "",
    yearFrom: "",
    yearTo: "",
    percentageCompletedId: 0,
    percentageCompletedLabel: "",
    rolesAndRespDescription: "",
    dateOfIncorporation: "",
};
// CAPS First Reference Object
export const CAPSFirstReferenceObject = {
    firstNameReference1: "",
    lastNameReference1: "",
    emailAddress: "",
    organisation: "",
    organisationAddress: "",
    relationship: "",
    contactNumber: "",
    applicantPeriodLength: "",
    firstReferenceSignaturePath: "",
};
// CAPS Second Reference Object
export const CAPSecondReferenceObject = {
    firstNameReference2: "",
    lastNameReference2: "",
    emailAddress: "",
    organisation: "",
    organisationAddress: "",
    relationship: "",
    contactNumber: "",
    applicantPeriodLength: "",
    secondReferenceSignaturePath: "",
};
// CAPS Project Info Summary Object
export const CAPSProjectInfoSummaryObject = {
    projectCiteWrittenReport: [],
    accreditedConProReportPath: "",
    isRequiredQuotation1: false,
    isRequiredQuotation2: false,
};
// CAPS Project Cite Written Object
export const CAPSProjectCiteWrittenObject = {
    projectTitle: "",
    projectValue: "",
    role: "",
    projectDuration: "",
    dateForm: "",
    dateTo: "",
    typeScopeDescription: "",
    projectRoleDecription: "",
    projectResponDescription: "",
    projectDocumentryProofPath: "",
    firstName: "",
    lastName: "",
    roleEndorsement: "",
    emailAddress: "",
    uploadSignaturePath: "",
};
